import React, { useState } from 'react';
import { request } from '../../../api/request.tsx';

interface UpdateStatusContactProps {
  formId: string;
  currentStatus?: string;
  onStatusUpdated?: () => void;
  onClose?: () => void;
}

const UpdateStatusContact: React.FC<UpdateStatusContactProps> = ({
  formId,
  currentStatus = 'pending',
  onStatusUpdated,
  onClose
}) => {
  const [status, setStatus] = useState(currentStatus);
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { value: 'pending', label: 'Đang chờ', color: 'bg-yellow-100 text-yellow-800' },
    { value: 'contacted', label: 'Đã liên hệ', color: 'bg-blue-100 text-blue-800' },
    { value: 'resolved', label: 'Đã giải quyết', color: 'bg-green-100 text-green-800' },
    { value: 'spam', label: 'Spam', color: 'bg-red-100 text-red-800' }
  ];

  const handleUpdateStatus = async () => {
    if (!formId) {
      alert('Form ID không hợp lệ');
      return;
    }

    setLoading(true);
    try {
      const response = await request('contact', {
        formId,
        status
      }, 'PUT');

    if (response?.status === true) {
        alert('Cập nhật trạng thái thành công!');
        onStatusUpdated?.();
        onClose?.();
      } else {
        alert('Có lỗi xảy ra khi cập nhật trạng thái');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Có lỗi xảy ra khi cập nhật trạng thái');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">Cập nhật trạng thái</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            ×
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Chọn trạng thái:
          </label>
          <div className="space-y-2">
            {statusOptions.map((option) => (
              <label
                key={option.value}
                className="flex items-center cursor-pointer p-3 rounded-lg border hover:bg-gray-50 transition-colors"
              >
                <input
                  type="radio"
                  name="status"
                  value={option.value}
                  checked={status === option.value}
                  onChange={(e) => setStatus(e.target.value)}
                  className="w-4 h-4 text-[pink] border-gray-300 focus:ring-pink-200 mr-3"
                />
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${option.color}`}>
                  {option.label}
                </span>
              </label>
            ))}
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Hủy
          </button>
          <button
            onClick={handleUpdateStatus}
            disabled={loading || status === currentStatus}
            className="flex-1 py-2 px-4 bg-[pink] text-white rounded-lg hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Đang cập nhật...' : 'Cập nhật'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateStatusContact;